import React, { useState } from 'react';
import './Header.css';

function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  return (
    <header className="header">
      <div className="header-container">
        {/* Logo */}
        <div className="logo-container">
       <a href="/">   <img src="https://i.postimg.cc/hGCKfCwZ/Nouveau-projet.png" alt="Logo" className="logo"  /></a>
        </div>

        {/* Navigation - Desktop */}
        <nav className="nav-desktop">
          <ul className="nav-links">
          <li><a href="/pricing"><p>Tarifs</p></a></li>
            <li><a href="/about"><p>Qui sommes-nous ?</p></a></li>
            <li><a href="/gallery"><p>Galerie</p></a></li>

            <li><a href="/qa"><p>FAQ</p></a></li>
          </ul>
          <a href="/book" className="reserve-button">Réserver</a>
        </nav>

        {/* Burger Menu - Mobile */}
        <div className="mobile-menu-container">
          <button 
            className={`burger-button ${mobileMenuOpen ? 'open' : ''}`} 
            onClick={toggleMobileMenu}
            aria-label="Menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>

      {/* Mobile Menu Overlay */}
      <div className={`mobile-menu ${mobileMenuOpen ? 'open' : ''}`}>
        <nav className="nav-mobile">
          <ul className="mobile-nav-links">
          <li><a href="/pricing" onClick={toggleMobileMenu}><p>Tarifs</p></a></li>
            <li><a href="/gallery" onClick={toggleMobileMenu}><p>Galerie</p></a></li>

            <li><a href="/about" onClick={toggleMobileMenu}><p>Qui sommes-nous ?</p></a></li>
            <li><a href="/qa" onClick={toggleMobileMenu}><p>FAQ</p></a></li>
          </ul>
          <a href="/book" className="reserve-button mobile" onClick={toggleMobileMenu}>Réserver</a>
        </nav>
      </div>
    </header>
  );
}

export default Header;